<template>
    <ProductsOverview :full-text-search-value="fullTextSearchValue" is-search />
</template>

<script setup lang="ts">
import { computed } from "vue";
import ProductsOverview from "@/abilities/product-and-asset/pages/products-overview.vue";

const props = defineProps<{
    search: Record<string, string>;
}>();

const fullTextSearchValue = computed(() => {
    return props.search.text;
});
</script>
